export default __webpack_public_path__ + "static/media/Comfortaa-SemiBold.7f56da50.ttf";